<template>
  <div class="site_nav d_flex  c_1A1A1A bc_fff">
    <div class="div_1">
      <span>政府网站</span>
      <span />
    </div>
    <div class="div_1">
      <span>交易机构</span>
      <span />
    </div>
    <div class="div_1">
      <span>相关网站</span>
      <span />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.site_nav{
margin: 0 0 10px 0;
border: 1px solid #E6E6E6;

.div_1{
    flex: 1;
    padding: 20px 0;
    text-align: center;
    &:nth-child(2){
        border-left: 1px solid #E6E6E6;
        border-right: 1px solid #E6E6E6;
    }
}
}
</style>
